export const HIGHLIGHT_PROJECT = 'HIGHLIGHT_PROJECT';
export const GLOW_PAGE_BORDER = 'GLOW_PAGE_BORDER';
export const SET_ACTIVE_SKILLS = 'SET_ACTIVE_SKILLS'; 